import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const NikshayEpisodeCard = ({ episodeDetails, selectedEpisodeId, onEpisodeChange, loading }) => {
  if (loading) {
    return (
      <div className="card mb-3 border-0 shadow-sm">
        <div className="card-body text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading Episode Details...</span>
          </div>
          <p className="mt-2 text-muted mb-0">Fetching episode information...</p>
        </div>
      </div>
    );
  }

  if (!episodeDetails) {
    return null;
  }

  const overview = episodeDetails?.overview || [];
  const patientId = overview.find((o) => o.PatientId)?.PatientId || "-";
  const currentEpisode = overview.find((o) => o.CurrentEpisode)?.CurrentEpisode || "-";
  const status = overview.find((o) => o.status)?.status || "-";
  
  const episodeData = episodeDetails?.episodeData || {};
  const stageData = episodeData?.stageData || {};
  const episodes = episodeDetails?.episodes || [];
  // const typeOfCaseFinding = stageData?.typeOfCaseFinding || "-";
  
  // Format Type of Episode / Sector
  let sector = "-";
  if (episodeData?.typeOfEpisode) {
    sector = episodeData.typeOfEpisode.replace("IndiaTb", "");
  }

  const currentStageId = episodeData?.currentStageId || 0;
  const stageKey = episodeData?.stageKey || "";

  // Helper to style timeline steps
  const getStepStyle = (stepNum) => {
    let isCompleted = false;
    let isActive = false;

    if (stepNum === 1) {
      isCompleted = true; // Add Case is always completed as we have a case
    } else if (stepNum === 2) {
      // Add Test is completed if we have reached diagnosed stage (stage 4) or higher
      isCompleted = currentStageId >= 4;
    } else if (stepNum === 3) {
      // Initiate Treatment is active if we are in Diagnosed stage but pending treatment
      isCompleted = currentStageId > 4;
      isActive = currentStageId === 4;
    } else if (stepNum === 4) {
      // Close Case is active when patient is on treatment and ready for outcome
      isCompleted = stageKey === "CLOSED" || currentStageId > 6;
      isActive = currentStageId > 4 && currentStageId <= 6;
    }

    if (isCompleted) {
      return {
        backgroundColor: "#82C382",
        color: "#fff",
        borderColor: "#82C382",
      };
    }
    if (isActive) {
      return {
        backgroundColor: "#fff",
        color: "#212529",
        borderColor: "#212529",
        fontWeight: "600",
      };
    }
    return {
      backgroundColor: "#fff",
      color: "#6c757d",
      borderColor: "#dee2e6",
    };
  };

  // Find current episode index for Episode No display
  const episodeNo = episodes.indexOf(Number(selectedEpisodeId)) + 1 || 1;

  return (
    <div className="card mb-4 shadow-sm border-0 bg-light">
      <div className="card-body">
        {/* Timeline Flow Steps */}
        {/* <div className="d-flex align-items-center flex-wrap mb-3 gap-2">
          <span className="badge rounded-pill px-3 py-2 border" style={getStepStyle(1)}>
            Add Case 1
          </span>
          <span className="text-muted fw-bold">»</span>
          <span className="badge rounded-pill px-3 py-2 border" style={getStepStyle(2)}>
            Add Test 2
          </span>
          <span className="text-muted fw-bold">»</span>
          <span className="badge rounded-pill px-3 py-2 border" style={getStepStyle(3)}>
            Initiate Treatment 3
          </span>
          <span className="text-muted fw-bold">»</span>
          <span className="badge rounded-pill px-3 py-2 border" style={getStepStyle(4)}>
            Close Case 4
          </span>
        </div> */}

        {/* Patient Details Grid */}
        <div className="row g-3 text-secondary" style={{ fontSize: "14px" }}>
          <div className="col-md-4">
            <div>
              Patient ID: <strong className="text-dark">{patientId}</strong>
            </div>
            <div className="mt-2">
              Sector: <strong className="text-dark">{sector}</strong>
            </div>
          </div>

          <div className="col-md-4">
            <div>
              Current Episode ID: <strong className="text-dark">{currentEpisode}</strong>
            </div>
            <div className="mt-2">
              Type of patient: <strong className="text-dark">{sector}</strong>
            </div>
            {/* <div className="mt-2">
              Status:{" "}
              <strong className="text-dark">
                {typeOfCaseFinding}
              </strong>
            </div> */}
          </div>

          <div className="col-md-4">
            <div>
              Status: <strong className="text-dark">{status}</strong>
            </div>
            {/* <div className="mt-2">
              Episode No: <strong className="text-dark">{episodeNo}</strong>
            </div> */}
            {/* <div className="mt-2 d-flex align-items-center gap-2">
              <span>Other Episode(s):</span>
              <select
                className="form-select form-select-sm w-auto d-inline-block"
                value={selectedEpisodeId || ""}
                onChange={(e) => onEpisodeChange(e.target.value)}
                style={{ minWidth: "120px" }}
              >
                {episodes.map((ep) => (
                  <option key={ep} value={ep}>
                    {ep}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NikshayEpisodeCard;
